<template>
  <div class="details" v-if="product">
    <div class="page-width display">
      <div class="content">
        <breadcrumb v-if='$i18n.locale=="en"' v-bind:path2.name="product.Name"></breadcrumb>
        <breadcrumb v-if='$i18n.locale=="ch"' v-bind:path2.name="product.Description"></breadcrumb>
        <div class="share"
          v-clipboard:copy="currentURL" 
          v-clipboard:success="copy"
        >
          <span>{{ $t('share') }}</span>
          <img src="../assets/img/share.png" alt="">
        </div>
        <div class="info">
          <!--product image-->
          <div class="productsingleli">
            <div class="ps_left">
              <div class="product-single__photo-wrapper sp-wrap">
                <!-- with zoom in -->
                <div v-show="zoom.screenWidth>773">
                  <vue-h-zoom
                    :image="bigImg || product.Images[0]"
                    :image-full="zoomImg || product.Large_Images[0]"
                    :zoom-level="2"
                    :width="zoom.width"
                    :height="zoom.height"
                    :zoom-window-size="1"
                    :zoom-window-x="zoom.zoomX"
                    :zoom-window-y="zoom.zoomY"
                  >
                  </vue-h-zoom>
                </div>
                <!-- no zoom in -->
                <div v-show="zoom.screenWidth<772">
                  <img class="mobile-image" :src="bigImg || product.Images[0]" alt="">
                </div>
              </div>
            </div>
            <div class="ps_right">
              <div class="thumbnails-wrapper">
                <ul>
                  <li v-for="(item,index) in product.Images" :class="isactive == index?'isactive':''" :key="index">
                    <a href="javascript:void(0)" @click="tabImg(index)"><img :src="item" alt=""></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!--end product image-->
          <!--product detail-->
          <div class="product-single__meta">
            <h1 class="product-single__title" v-if='$i18n.locale=="en"'>{{product.Name}}</h1>
            <h1 class="product-single__title" v-if='$i18n.locale=="ch"'>{{product.Description}}</h1>
            <div class="product_reviews_below_title">
              <div class="delivery_txt">
                <span v-show="product.StockLevel<product.MinStockRange&&product.StockLevel>0">{{product.StockLevel}} {{ $t('leftInStock') }}</span>
              </div>
              <div class="delivery_txt">
                <span>{{ $t('referenceNumber') }}:</span>
                  <span>{{product.RefNum}}</span>
              </div>
              <div class="delivery_txt">
                <span>UPC:</span>
                    <span>{{product.Barcode}}</span>
              </div>
              <div class="location_txt">
                  <span>{{ $t('location') }}:</span>
                    <span>{{product.location}}</span>
              </div>
              <div class="shipping_link">
                <a href="/returns-and-refunds">{{ $t('shippingInformation') }}</a>
              </div>
              
              <div class="group" v-if='product.EndTime'>
                <div class="groupText">{{ $t('groupBuyingInProgress') }}</div>
                <div class="countdownTimerContainer">
                  <p v-if='$i18n.locale=="en"' class="countdownTimer">{{this.timeDay}}<span>D</span> {{this.timeHour}}<span>H</span> {{this.timeMin}}<span>M</span> {{this.timeSec}}<span>S</span></p>
                  <p v-if='$i18n.locale=="ch"' class="countdownTimer">{{this.timeDay}}<span>天</span>{{this.timeHour}}<span>时</span>{{this.timeMin}}<span>分</span>{{this.timeSec}}<span>秒</span></p>
                </div>
                <div class="remainingContainer">
                  <p v-if='$i18n.locale=="en"'>{{this.product.GroupedSaleLimit - this.product.GroupSoldQuantity}} Items Left!</p>
                  <p v-if='$i18n.locale=="ch"'>剩下: {{this.product.GroupedSaleLimit - this.product.GroupSoldQuantity}} 件!</p>
                </div>
              </div>

              <div class="price-marge">
                  <div :class="['product__price', product.IsPromotion ? 'hot' : '']"><span>${{product.Price.toFixed(2)}}</span></div>
                  <div class="price_original_detail_page" v-show="product.IsPromotion"><span>${{product.OriginalPrice}}</span></div>
              </div>
              <div class="qty_and_cart">
                <!--qty-->
                <div class="mobileqty">
                  <!-- <label class="qty_lebel">QTY</label> -->
                  <div class="qty_input">
                    <el-input-number v-model="num" size="small" :min="1" :max="product.StockLevel" label=""></el-input-number>
                  </div>
                </div>
                <!--end qty-->
                <!--add to cart btn-->
                <div v-if="product.StockLevel>0" class="product-form__item product-form__item--submit product-form__item--no-variants">
                  <!-- <input v-on:click="addToCart(product)" type="button" class="btn product-form__cart-submit fakeBUt" value="Add to Cart"> -->
                  <button :disabled="this.addDisabled" v-on:click="addToCart(product)" name="add" id="AddToCart-product-template" class="btn product-form__cart-submit">
                    <span id="AddToCartText-product-template">{{ $t('addToCart') }}</span>
                  </button>
                </div>
                <div v-else class="product-form__item product-form__item--submit product-form__item--no-variants">
                  <input type="button" class="btn product-form__cart-submit fakeBUt" value="Sold out">
                  <button style="display:none;" name="add" id="AddToCart-product-template" class="btn product-form__cart-submit">
                    <span id="AddToCartText-product-template">{{ $t('soldOut') }}</span>
                  </button>
                </div>
                <!--end add to cart btn -->
              </div>
              <!-- <span class="time_tip">{{activeQuantity}} {{ $t('currentlyInCart') }}</span> -->
              <div v-if="product.IsProposition65" class="warning">
                <img src="../assets/img/warning.png" alt="">
                <span>
                  For more information: 
                  <a class="warning-link" href="https://www.p65warnings.ca.gov/">www.P65Aarnings.ca.gov</a>
                </span>
              </div>
            </div>
          </div>
          <!--end product detail-->
        </div>
      </div>
    </div>
    <div class="page-width group_900" v-if='product.EndTime'>
      <div class="content">
        <div class="groupText">{{ $t('grouping') }}:</div>
         <div class="countdownTimerContainer">
          <p v-if='$i18n.locale=="en"' class="countdownTimer">{{this.timeDay}}<span>D</span> {{this.timeHour}}<span>H</span> {{this.timeMin}}<span>M</span> {{this.timeSec}}<span>S</span></p>
          <p v-if='$i18n.locale=="ch"' class="countdownTimer">{{this.timeDay}}<span>天</span>{{this.timeHour}}<span>时</span>{{this.timeMin}}<span>分</span>{{this.timeSec}}<span>秒</span></p>
         </div>
         <div class="remainingContainer">
          <p v-if='$i18n.locale=="en"'>{{this.product.GroupedSaleLimit - this.product.GroupSoldQuantity}} Items Left!</p>
          <p v-if='$i18n.locale=="ch"'>剩下: {{this.product.GroupedSaleLimit - this.product.GroupSoldQuantity}} 件!</p>
         </div>
      </div>
    </div>
    <div class="page-width">
      <!--description-->
      <div class="product-single__description rte">
        <h2>{{ $t('description') }}</h2>
        <template></template>
        <p v-if="product.rich_text_description">
          <span v-html="product.rich_text_description"></span>
        </p>
      </div>
      <!--end description-->
      
      <!--recommended-->
      <div class="Trending" v-for="(item, index) in this.$store.state.products.customCategories.slice(-1)" :key='index'>
        <div v-if="item.Products.length !== 0">
          <h2 class="section-header__title">{{item.Name}}</h2>
          <div class="grid--uniform grid--view-items">
            <swiper :options="productSwiper" ref="mySwiper">
              <!-- slides -->
              <swiper-slide v-for="(p, index) in item.Products" :key='index'>
                <productCard v-if='$i18n.locale=="en"'
                  v-bind:img="p.Thumbnail"
                  v-bind:link="p.link"
                  v-bind:name="p.Name"
                  v-bind:isPromotion="p.isPromotion"
                  v-bind:price="p.Price"
                  v-bind:item="p"
                  v-bind:quantity="p.Quantity"
                  v-bind:key="index" 
                  v-bind:endTime="p.EndTime"
                  v-bind:GroupedSaleLimit="p.GroupedSaleLimit"
                  v-bind:GroupSoldQuantity="p.GroupSoldQuantity"
                ></productCard> 
                <!-- v-bind:inCart="inCart" -->
                <productCard v-if='$i18n.locale=="ch"'
                  v-bind:img="p.Thumbnail"
                  v-bind:link="p.link"
                  v-bind:name="p.Description"
                  v-bind:isPromotion="p.isPromotion"
                  v-bind:price="p.Price"
                  v-bind:item="p"
                  v-bind:quantity="p.Quantity"
                  v-bind:key="index" 
                  v-bind:endTime="p.EndTime"
                  v-bind:GroupedSaleLimit="p.GroupedSaleLimit"
                  v-bind:GroupSoldQuantity="p.GroupSoldQuantity"
                ></productCard> 
              </swiper-slide>
            </swiper>
            <div v-if="item.Products.length>5" class="swiper-button-prev swp2"></div>
            <div v-if="item.Products.length>5" class="swiper-button-next swp2"></div>
          </div>
        </div>
      </div>
      <!--end recommended-->
    </div>

  </div>
</template>
<script type="text/javascript">
  Vue.use(VueHZoom);
</script>
<script>
import moment from 'moment';
import { mapActions, mapMutations, mapState } from 'vuex';
import Router from 'vue-router';
import Vue from 'vue';
import smoothproducts from '../assets/js/smoothproducts.min';
import breadcrumb from '../components/breadcrumb'
import {
  isUserAuthenticated,
  setLocalCart,
  getLocalCart
} from "../store/modules/cart";
import productCard from "./productCard";
import VueHZoom from 'vue-h-zoom';
Vue.use(VueHZoom);
Vue.component('originalVueZoom', VueHZoom);
const newZoom = Vue.component('originalVueZoom').extend({
  methods: {
    updateThumbnailPos: function () {
      const el = this.$refs.thumbnail;
      let elementDim = el.getBoundingClientRect();
      this.thumbnailPos = {
        top: elementDim.top,
        left: elementDim.left,
      }
    }
  }
});
export default {
  name: "productDetails",
  components: {
    breadcrumb,
    VueHZoom: newZoom,
    productCard,
  },
  data() {
    return {
      addDisabled: false,
      currentTime: new Date(),
      timeDay: null,
      timeHour: null,
      timeMin: null,
      timeSec: null,

      zoom: {
        screenWidth: 0,
        width: 0,
        height: 0,
        zoomX: 0,
        zoomY: 0,
      },
      num: 0, // number count
      currentURL: '',
      review: 0,
      cartCount: 0,
      productDetail: {},
      productSwiper: {
        slidesPerView: 5,
        navigation: {
          nextEl: '.swiper-button-next.swp2',
          prevEl: '.swiper-button-prev.swp2',
        },
        breakpoints: {
          320: {
            slidesPerView: 2,
          },
          //when width >= 480
          480:{
            slidesPerView: 2,
          },
          767: {
            slidesPerView: 2,
          },
          //when width >= 640
          990: {
            slidesPerView: 3,
          },
          1200:{
            slidesPerView: 4,
          },
          1280: {
            slidesPerView: 5,
          }
        }
      },
      bigImg: "",
      zoomImg: "",
      isactive: 0, //click
      //review info 
      reviews:false,//show rview submit
      ruleForm: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      rules: {
        name: [
          {required: true, errorMessage: 'name can not be empty', trigger: 'blur'}
        ],
        email: [
          {required: true, errorMessage: 'email can not be empty', trigger: 'blur'}
        ],
        title: [
          {required: true, errorMessage: 'title can not be empty', trigger: 'blur'}
        ],
        body: [
          {required: false, errorMessage: '', trigger: 'blur'}
        ]
      },
      value2: null, //piclk star level
      colors: ['#99A9BF', '#F7BA2A', '#FF9900'] //star color = { 2: '#99A9BF', 4: { value: '#F7BA2A', excluded: true }, 5: '#FF9900' }
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    ...mapActions('products', ['fetchProductDetails']),
    ...mapActions('cart', ['addProductToCart']),
    ...mapMutations('products', ['updateActiveProduct', 'updateActiveQuantity']),
    ...mapMutations('checkout', ['setPricesForCheckout', 'saveTotalPrice', 'saveGrandTotal', 'clearPromoCode', 'clearCard']),
    tabImg(num) {
      this.bigImg = this.product.Images[num]; // right side big img
      this.zoomImg = this.product.Large_Images[num]; // zoom big img
      this.isactive = num; // tab the img
    },
    copy() {
      this.$notify({
        type: 'success',
        title: '复制成功',
        // message: '分享链接给好友',
        position: 'bottom-right',
        duration: 2000
      });
    },
    initializeTabImg() {
      this.bigImg = "";
      this.zoomImg = "";
      this.isactive = 0;
    },
    goToProductDetail(product) {
      this.$router.push({
        name: 'productDetails',
        query: { productNum: product.ProductNum}
      })
    },
    handleResize() {
      this.zoom.screenWidth = window.innerWidth;
      if (this.zoom.screenWidth>1139) {
        this.zoom.width = 400;
        this.zoom.height = 400;
        this.zoom.zoomX = 400;
        this.zoom.zoomY = 100;
      } else if (this.zoom.screenWidth<1140 && this.zoom.screenWidth>892) {
        this.zoom.width = 300;
        this.zoom.height = 300;
        this.zoom.zoomX = 400;
        this.zoom.zoomY = 100;
      } else if (this.zoom.screenWidth<893 && this.zoom.screenWidth>772) {
        this.zoom.width = 278;
        this.zoom.height = 278;
        this.zoom.zoomX = 300;
        this.zoom.zoomY = 100;
      }
    },
    handleAddToCartSuccess(payload) {
      this.$store.dispatch('cart/addCart', payload.item)
      .then(() => {
        this.$store.dispatch('cart/getCart')
      })
    },
    handleAddToCartFail(product) {
      alert(`Sorry, there are only ${product.StockLevel} available of ${product.Name}`);
    },
    addToCart: function(item) {
      this.addDisabled = true;
      setTimeout(() => this.addDisabled = false, 1000);

      item.quantity = this.num;
      if (isUserAuthenticated()) {
        this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item})
      } else {
        this.$store.dispatch('cart/addProductToLocalCart', item)
      }
    },
    // review list change
    customerList() {
      this.reviews = !this.reviews
    },
    submitForm(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!');
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    if (isUserAuthenticated() && to.name === 'purchase') {
      this.$store.dispatch('cart/getCart')
        .then(() => {
        const cartItems = {};
        cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
        cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
        cartItems.ShippingMethod = "Delivery";
        cartItems.Tip = 0;
        cartItems.TipPercentage = 0;
        cartItems.TotalPrice = this.$store.state.cart.cartProductsList.TotalPrice;
        cartItems.IsShareCreditUsed = this.IsShareCreditUsed;
        this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
        .then(() => {
          this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
        })
      })
    }
    this.clearPromoCode();
    this.clearCard();
    next();
  },
  computed: mapState({
    activeProduct: state => state.products.activeProduct,
    product: state => state.products.productDetails[0],
    necessaryCartItems: state => state.cart.necessaryCartItems,
    cart: state => state.cart.cart,
    cartProductsList: state => state.cart.cartProductsList,
    productDetails: state => state.products.productDetails,
    itemCount: state => state.cart.itemCount,
    itemDeleted: state => state.cart.itemDeleted,
    activeQuantity: state => state.products.activeQuantity,
    IsShareCreditUsed: (state) => state.checkout.IsShareCreditUsed,
  }),
  watch: {
    '$route.query': {
      immediate: true,
      handler(newVal) {
        this.fetchProductDetails(newVal.productNum);
        this.updateActiveProduct(newVal.productNum);
        this.$store.dispatch('products/fetchCustomCategories');
        this.initializeTabImg();
        this.currentURL = 'https://www.morningplaza.com' + this.$route.fullPath;
      }
    },
    cartProductsList: {
      deep: true, 
      handler(newVal) {
        let quantFound = false;
        //Unfortunately, because `item.quantity` is used in other places, we can't combine the authenticated and unauthenticated mapping into one function and use || to delineate between the local storage cart and api cart. --Anthony
          if (isUserAuthenticated()) {
            this.cartProductsList.Sales_Order_Lines.map(item => {
              if (item.ProductNum === this.activeProduct) {
                quantFound = true;
                this.updateActiveQuantity(item.Quantity)
              }
            })
          } else {
              this.cartProductsList.map(item => {
              if (item.ProductNum === this.activeProduct) {
                quantFound = true;
                this.updateActiveQuantity(item.quantity)
              }
            })
          }
        if (!quantFound) {
          this.updateActiveQuantity(0);
        }
      }
    },
    product: function(newVal, oldVal) {
      let that = this;
      if (this.product && this.product.EndTime !== null) {
        setInterval( function(){that.currentTime = new Date();}, 1000);
      }
    },
    currentTime: function(newVal, oldVal) {
      if (this.product && this.product.EndTime) {
        let diffTime = Math.abs(moment(this.product.EndTime) - moment(this.currentTime)) / 1000;
        this.timeDay = Math.floor(diffTime / 86400);
        diffTime -= this.timeDay * 86400;
        if (this.timeDay < 10) {
          this.timeDay = '0' + this.timeDay;
        }
        this.timeHour = Math.floor(diffTime / 3600) % 24;
        diffTime -= this.timeHour * 3600;
        if (this.timeHour < 10) {
          this.timeHour = '0' + this.timeHour;
        }
        this.timeMin = Math.floor(diffTime / 60) % 60;
        diffTime -= this.timeMin * 60;
        if (this.timeMin < 10) {
          this.timeMin = '0' + this.timeMin;
        }
        this.timeSec = Math.floor(diffTime % 60);
        if (this.timeSec < 10) {
          this.timeSec = '0' + this.timeSec;
        }
      }
    },
  }
}
$(function () {
  $('.sp-wrap').smoothproducts();
})
</script>

<style lang="less" scope>
@import "../assets/css/public.less";
@import "../assets/css/details.less";
@import "../assets/css/jqzoom.css";
@import "../assets/css/navbar.less";
@import "../assets/css/smoothproducts.css";
</style>



// WEBPACK FOOTER //
// src/view/productDetails.vue